module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"note.add.label":"เพิ่ม Note","note.modal.title":"Drone Note Editor","note.pin":"ปักหมุด","note.add.success":"ทำการเพิ่ม Note ใหม่เรียบร้อย","note.update.success":"ทำการแก้ไข Note ใหม่เรียบร้อย","note.delete.title":"ยืนยันการลบ Note","note.delete.message":"คุณต้องการลบ Note นี้ ?","note.delete.success":"ทำการลบ Note เรียบร้อย"}}')
  delete Component.options._Ctor
}
